import React, { useState } from "react";
import { portfolioData } from "../../../Works/data/portfolioData";
import "./SectionPortfolio.scss";

const isKorean = () => {
  const lang = localStorage.getItem("i18nextLng") || "en";
  return lang === "kr" || lang.startsWith("ko");
};

interface CategoryMeta {
  key: string;
  index: string;
  label: string;
  subtitle: string;
  accent: string;
}

const categoryMeta: CategoryMeta[] = [
  { key: "system", index: "01", label: "SYSTEM", subtitle: "System Engineering & Platform", accent: "#deff72" },
  { key: "interactive", index: "02", label: "INTERACTIVE", subtitle: "Immersive Experience & Interactive Media", accent: "#72d4ff" },
  { key: "2d", index: "03", label: "2D", subtitle: "Character IP & 2D Visual Identity", accent: "#ff72b4" },
  { key: "3d", index: "04", label: "3D", subtitle: "3D Character & Digital Sculpt", accent: "#c872ff" },
  { key: "game", index: "05", label: "GAME", subtitle: "Global Game Art & Asset Production", accent: "#ffb872" },
];

const totalProjects = categoryMeta.reduce(
  (sum, cat) => sum + (portfolioData[cat.key]?.length || 0),
  0
);

function SectionPortfolio() {
  const [hoveredIdx, setHoveredIdx] = useState<number | null>(null);
  const kr = isKorean();

  return (
    <section className="section-portfolio">
      <div className="sp-container">
        <div className="sp-header">
          <span className="sp-header__label">PORTFOLIO</span>
          <span className="sp-header__total">{totalProjects} Projects</span>
        </div>

        <div
          className={`sp-columns ${hoveredIdx !== null ? "sp-columns--has-hover" : ""}`}
          onMouseLeave={() => setHoveredIdx(null)}
        >
          {categoryMeta.map((cat, idx) => {
            const items = portfolioData[cat.key] || [];
            const isHovered = hoveredIdx === idx;
            const isOther = hoveredIdx !== null && !isHovered;

            return (
              <div
                key={cat.key}
                className={`sp-col ${isHovered ? "sp-col--active" : ""} ${isOther ? "sp-col--dimmed" : ""}`}
                style={{ "--accent": cat.accent } as React.CSSProperties}
                onMouseEnter={() => setHoveredIdx(idx)}
              >
                {/* Column Header */}
                <div className="sp-col__header">
                  <div className="sp-col__header-top">
                    <span className="sp-col__index">{cat.index}</span>
                    <span className="sp-col__count">{items.length}</span>
                  </div>
                  <h3 className="sp-col__label">{cat.label}</h3>
                  <p className="sp-col__subtitle">{cat.subtitle}</p>
                  <div className="sp-col__divider" />
                </div>

                {/* Project List */}
                <ul className="sp-col__list">
                  {items.map((item, i) => (
                    <li key={i} className="sp-col__item">
                      <span className="sp-col__client">{item.client}</span>
                      <span className="sp-col__desc">{kr ? item.description : item.descriptionEn}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default SectionPortfolio;
